import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkStringify from 'remark-stringify';
import remarkStripMarkdown from 'strip-markdown';
import remarkFrontmatter from 'remark-frontmatter';

const processor = unified()
  .use(remarkParse)
  .use(remarkStripMarkdown)
  .use(remarkStringify)
  .use(remarkFrontmatter, ['yaml']);

export default function stripMarkdown(input: string): string {
  const result = processor.processSync(input).toString().trim();

  // Unescape characters that were escaped by the markdown processor
  // but should be preserved as-is for malformed markdown
  return result
    .replace(/\\(\[)/g, '$1') // Unescape square brackets
    .replace(/\\(\*)/g, '$1') // Unescape asterisks
    .replace(/\\(`)/g, '$1') // Unescape backticks
    .replace(/(?:\r?\n)+/g, ' ') // Replace newlines (Unix/Windows) with spaces
    .replace(/\s+/g, ' ') // Collapse multiple spaces
    .trim();
}
